import React, { useEffect } from 'react';
import { FaPhoneSlash, FaVideo, FaVideoSlash } from 'react-icons/fa';

const CallModal = React.forwardRef(({
  isOpen,
  onClose,
  callStatus,
  isVideoCall,
  isLocalVideoActive,
  onToggleVideo,
  roomName,
  avatarUrl,
}, ref) => {

  useEffect(() => {
    if (isOpen && ref.localVideoRef?.current && window.localStream) {
       ref.localVideoRef.current.srcObject = window.localStream;
    }
  }, [isOpen, ref.localVideoRef]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col">
        <div className="p-6 flex flex-col items-center text-center">
          <div className="w-20 h-20 rounded-full border-4 border-gray-100 shadow-sm overflow-hidden bg-gray-50 mb-4 mx-auto">
            <img
              src={avatarUrl}
              className="w-full h-full object-cover"
              alt="avatar"
              onError={(e) => { e.target.src = 'https://via.placeholder.com/80?text=User'; }}
            />
          </div>
          <h2 className="text-xl font-bold text-gray-900">{roomName}</h2>
          <p className="text-[#002B5B] font-bold text-xs uppercase mt-1 tracking-wider">{callStatus}</p>
        </div>

        {isVideoCall && (
          <div className="relative bg-gray-900 aspect-video w-full overflow-hidden shadow-inner">
            <video
              ref={ref.remoteVideoRef}
              autoPlay
              playsInline
              className="w-full h-full object-cover bg-black"
            />
            <div className="absolute bottom-2 right-2 w-24 h-32 bg-black rounded-lg overflow-hidden border border-white/20 shadow-2xl z-10">
              <video
                ref={ref.localVideoRef}
                autoPlay
                playsInline
                muted
                className={`w-full h-full object-cover transition-opacity duration-500 ${isLocalVideoActive ? 'opacity-100' : 'opacity-0'}`}
              />
              {!isLocalVideoActive && (
                 <div className="absolute inset-0 bg-gray-800 flex items-center justify-center">
                   <FaVideoSlash className="text-white/40" size={24} />
                 </div>
              )}
            </div>
          </div>
        )}

        <div className="p-6 bg-gray-50 flex justify-center space-x-8">
          {isVideoCall && (
            <button
              type="button"
              onClick={onToggleVideo}
              className={`w-14 h-14 rounded-full flex items-center justify-center transition-all shadow-md ${
                isLocalVideoActive ? 'bg-[#002B5B] text-white' : 'bg-white border-2 border-[#002B5B] text-[#002B5B]'
              }`}
            >
              {isLocalVideoActive ? <FaVideo size={22} /> : <FaVideoSlash size={22} />}
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className="w-14 h-14 rounded-full bg-red-500 text-white flex items-center justify-center shadow-lg active:scale-95 transition-transform"
          >
            <FaPhoneSlash size={22} />
          </button>
        </div>
      </div>
    </div>
  );
});

export default CallModal;
